import { render, staticRenderFns } from "./LegalAgreement.vue?vue&type=template&id=ddd6b2e2&"
import script from "./LegalAgreement.vue?vue&type=script&lang=js&"
export * from "./LegalAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports